import { IOption } from '../interfaces/common/i-option';

/** camera position, i.e. where the camera is located (left hand of hitter, right hand of hitter) when video was recorded */
// compared w/ HitterSide which only has LHH and RHH, so CEN should count for both or neither
export enum CameraPosition {
  LHH = 'LHH',
  CEN = 'CEN',
  RHH = 'RHH',
}

export const CAMERA_POSITIONS: IOption[] = [
  {
    label: 'constants.camera-lhh-box',
    value: CameraPosition.LHH,
  },
  {
    label: 'constants.camera-center',
    value: CameraPosition.CEN,
  },
  {
    label: 'constants.camera-rhh-box',
    value: CameraPosition.RHH,
  },
];

export enum GenerateStadium {
  Default = 'Default',
}

export enum StereoVideoType {
  Annotated = 'annotated', // videos w/ baked-in decorations like the SZ and speed, etc...
  Raw = 'raw', // only relevant for fires and shots
  Replay = 'replay', // videos w/o any decorations
  Spins = 'spins', // only relevant for fires and shots
}

/** `{type}_video_id` field on fires, shots, etc. */
export type StereoVideoIdField = `${StereoVideoType}_video_id`;

export const stereoVideoIdField = (type: StereoVideoType): StereoVideoIdField =>
  `${type}_video_id`;

/** video types synced onto session hits and pitch recaps */
export type HitRecapVideoType =
  | StereoVideoType.Annotated
  | StereoVideoType.Replay;

/** `{type}_video_id` field on nested session-hit fire details */
export type HitRecapVideoIdField = `${HitRecapVideoType}_video_id`;

export const hitRecapVideoIdField = (
  type: HitRecapVideoType
): HitRecapVideoIdField => `${type}_video_id`;

// * DISABLE THIS TO TURN OF AUTO-USE TOP SUGGESTION
export const AUTO_USE_TOP_SUGGESTION = true;
